import axios from "axios";
import { setMealBalance, setMealBalanceDollars } from "../redux/cartReducer/actions";

/**
 * Fetches customer meal balance from the API and updates Redux store
 * @param {Function} dispatch - Redux dispatch function
 * @param {string} firstName - Customer first name
 * @param {string} roomNumber - Customer room number or customer number
 * @param {string} apiBaseURL - Base API URL
 * @param {string} serverId - Server ID
 * @param {string} siteId - Site ID
 * @param {string} storeId - Store ID
 * @returns {Promise<Object|null>} Customer data or null if failed
 */
export const fetchAndUpdateMealBalance = async (
  dispatch,
  firstName,
  roomNumber,
  apiBaseURL,
  serverId,
  siteId,
  storeId
) => {
  try {
    const loginCustomerNumber = process.env.REACT_APP_LOGIN_CUSTOMER_NUMBER;

    const url =
      loginCustomerNumber === "1"
        ? `${apiBaseURL}/customer/login-customer-number/${serverId}/${siteId}/${firstName}/${roomNumber}`
        : `${apiBaseURL}/customer/login/${serverId}/${siteId}/${storeId}/${firstName}/${roomNumber}`;

    const response = await axios.get(url);
    const customer = response.data;

    // Validate customer data
    if (
      customer.FirstName.toLowerCase() === firstName.toLowerCase() &&
      (customer.Address1.toLowerCase() === roomNumber.toLowerCase() ||
        customer.CustomerNumber == roomNumber)
    ) {
      // Update meal count balance
      dispatch(setMealBalance(customer.MealCount));

      // Update meal balance in dollars
      const posType = sessionStorage.getItem("SIC_POSType");
      if (posType === "0" && customer.SIC_Balance !== undefined) {
        dispatch(setMealBalanceDollars(customer.SIC_Balance));
      } else {
        dispatch(setMealBalanceDollars(customer.CreditLimit - customer.AvailableCredit));
      }

      return customer;
    } else {
      console.warn("Customer validation failed");
      return null;
    }
  } catch (error) {
    console.error("Failed to fetch meal balance:", error);
    return null;
  }
};

/**
 * Convenience function to get formatted meal balance in dollars
 * @param {number} mealBalanceDollars - Raw meal balance in cents
 * @returns {string} Formatted balance as currency string
 */
export const formatMealBalance = (mealBalanceDollars) => {
  if (mealBalanceDollars === undefined || mealBalanceDollars === null) {
    return "0.00";
  }
  const mBal = Math.abs(mealBalanceDollars / 100);
  return mBal.toFixed(2);
};